import React from "react";

const Footer = () => {
    return (
        <div className="footer">
            <img src="../images/LOGOPHIL2.svg" alt="" />
            <img className="logo-entreprise" src="../images/logodbwb.png" alt="" />
            <p>©2023 dbwb - Tous droits réservés</p>
            <a href="https://www.themoviedb.org/"><img className="logo-fb" src="../images/logo-fb.png" alt="" /></a>
        </div>
    )
}

export default Footer;